import { render, staticRenderFns } from "./MobileOrderStoreList.vue?vue&type=template&id=41134558&"
import script from "./MobileOrderStoreList.vue?vue&type=script&lang=js&"
export * from "./MobileOrderStoreList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports